define((require) => {
    "use strict";

    const ProjectDashboardImageLibrary = require("ui/projects/image/ProjectDashboardImageLibrary");
    const $                            = require("jquery");
    const DashboardImageLibraryView    = require("ui/imageLibrary/DashboardImageLibraryView");
    /**
     *
     *
     * @class ProjectDashboardImageLibraryView
     */
    return DashboardImageLibraryView.extend({

        className: "project-" + DashboardImageLibraryView.prototype.className, // "project-dashboard-image-view",

        imageLibraryClass: ProjectDashboardImageLibrary,

        initialize() {
            const self = this;

            this.collectionViewOptions = {
                itemEvents: {
                    detach(model) {
                        self.collection.remove(model);
                    }
                }
            };

            this.__super();
        },

        itemViewOptions() {
            return {
                project: this.options.project,
                showImageActionsPanel: true
            };
        },

        onShow() {
            this.__super();

            const $attachButton = $("<button class='attach-button btn btn-grey pull-right'>Attach</button>");

            // Disable attach button if insufficient privileges...
            if (this.options.spectatorMode) {
                $attachButton.addClass("disabled").attr("disabled", true);
            } else {
                $attachButton.click(() => {
                    this.viewScope.openAttachLightbox({
                        imageLibrarySorting: this.options.imageLibrarySorting
                    });
                });
            }

            this.imageLibraryRegion.$el.prepend($attachButton);
        },

        /**
         * Invoked when any assets has been attached to the current project.
         *
         * Refreshes the current collection view to include the newly attached assets.
         */
        onAttachAsset() {
            this._imageLibraryView.refresh();
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/projects/image/ProjectDashboardImageLibraryView.js